import { StepRegistrationState } from 'reducers/registration/stepRegistrationReducer'

/**
 * Данные, которые сохранили в localStorage, до регистрации пользователя.
 * @param state
 */
export const shouldSaveStepRegistrationExtraData = (
  state: Partial<StepRegistrationState>
) => Boolean(state?.targetGender)
